<div class="ri-dialog">

  @if (submitted()) {
    <div class="ri-success">
      <div class="ri-success__icon">
        <mat-icon>check_circle</mat-icon>
      </div>
      <h2 class="ri-success__title">{{ 'Report submitted' | translate }}</h2>
      <p class="ri-success__sub">{{ 'Thank you for helping us improve the app.' | translate }}</p>
      <button class="ri-btn ri-btn--primary" (click)="close()">{{ 'Close' | translate }}</button>
    </div>
  } @else {
    <div class="ri-header">
      <div class="ri-header__icon">
        <mat-icon>bug_report</mat-icon>
      </div>
      <div>
        <h2 class="ri-header__title">{{ 'Report a problem' | translate }}</h2>
        <p class="ri-header__sub">{{ 'Describe the issue and we will look into it.' | translate }}</p>
      </div>
      <button class="ri-close" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="ri-body">
      <div class="ri-field">
        <label class="ri-label">{{ 'Summary' | translate }} <span class="ri-required">*</span></label>
        <input
          class="ri-input"
          [(ngModel)]="summary"
          [placeholder]="'Brief description of the issue' | translate"
          maxlength="120"
        />
        <span class="ri-char-count">{{ summary.length }}/120</span>
      </div>

      <div class="ri-field">
        <label class="ri-label">{{ 'Description' | translate }} <span class="ri-required">*</span></label>
        <textarea
          class="ri-textarea"
          [(ngModel)]="description"
          [placeholder]="'What happened? What did you expect? Steps to reproduce...' | translate"
          rows="6"
          maxlength="2000"
        ></textarea>
        <span class="ri-char-count">{{ description.length }}/2000</span>
      </div>
    </div>

    <div class="ri-footer">
      @if (!isValid) {
        <span class="ri-hint">
          <mat-icon>info</mat-icon>
          {{ validationHint | translate }}
        </span>
      }
      <button class="ri-btn ri-btn--ghost" (click)="close()">{{ 'Cancel' | translate }}</button>
      <button
        class="ri-btn ri-btn--primary"
        [disabled]="!isValid || submitting()"
        (click)="submit()"
      >
        @if (submitting()) {
          <mat-icon class="ri-spin">sync</mat-icon>
        } @else {
          <mat-icon>send</mat-icon>
        }
        {{ 'Submit' | translate }}
      </button>
    </div>
  }

</div>
